import { z } from 'zod';
import type { Translate } from './login.schema';

/**
 * Validation for the forgot-password form. Output matches the argument shape of
 * `authService.requestPasswordReset({ email, tenantCode })`.
 */
export function createForgotPasswordSchema(t: Translate) {
  return z.object({
    tenantCode: z.string().trim().min(1, t('auth.tenantCodeRequired')),
    email: z
      .string()
      .trim()
      .min(1, t('auth.emailRequired'))
      .email(t('auth.emailInvalid')),
  });
}

export type ForgotPasswordFormValues = z.infer<
  ReturnType<typeof createForgotPasswordSchema>
>;
